import * as shared from "./application";


// export const ServiceProxy = new shared.ServiceProxy(
//   "http://localhost:8000");

export const ServiceProxy = new shared.ServiceProxy(
  "https://main-events-backend.xpay.app");
